class FloatingATC extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.mainBuyButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
    
    this.init();
  }

  init() {
    if (!this.mainBuyButton) return;
    
    this.footer = document.querySelector('footer.zf');
    this.isAboveButton = true;
    this.isAboveFooter = true;
    
    // Set up intersection observer to show/hide floating ATC
    this.setupObserver();
    
    // Subscribe to variant change events
    this.subscribeToVariantChanges();
  }

  setupObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.target === this.mainBuyButton) {
          // Track if we're above or below the button
          this.isAboveButton = entry.isIntersecting || entry.boundingClientRect.top > 0;
        } else if (entry.target === this.footer) {
          // Hide floating ATC when footer is visible
          this.isAboveFooter = !entry.isIntersecting;
        }
      });
      this.updateVisibility();
    }, options);

    this.observer.observe(this.mainBuyButton);
    if (this.footer) {
      this.observer.observe(this.footer);
    }
  }

  updateVisibility() {
    // Only show if we're below the button AND above the footer
    if (!this.isAboveButton && this.isAboveFooter) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }

  subscribeToVariantChanges() {
    // Listen for variant change events
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId !== this.sectionId) return;
      
      this.updateFloatingATC(event.data.html, event.data.variant);
    });
  }

  updateFloatingATC(html, variant) {
    if (!html || !variant) return;

    // Update product image
    const newImage = html.querySelector('.floating-atc__image');
    const currentImage = this.querySelector('.floating-atc__image');
    if (newImage && currentImage) {
      currentImage.innerHTML = newImage.innerHTML;
    }

    // Update variant title
    const newVariant = html.querySelector('.floating-atc__variant');
    const currentVariant = this.querySelector('.floating-atc__variant');
    if (newVariant && currentVariant) {
      currentVariant.innerHTML = newVariant.innerHTML;
    } else if (!newVariant && currentVariant) {
      currentVariant.remove();
    } else if (newVariant && !currentVariant) {
      const details = this.querySelector('.floating-atc__details');
      if (details) {
        details.insertAdjacentHTML('beforeend', newVariant.outerHTML);
      }
    }

    // Update button state and text
    const newButton = html.querySelector(`#FloatingSubmitButton-${this.sectionId}`);
    const currentButton = this.querySelector(`#FloatingSubmitButton-${this.sectionId}`);
    
    if (newButton && currentButton) {
      // Update disabled state
      if (newButton.hasAttribute('disabled')) {
        currentButton.setAttribute('disabled', 'disabled');
      } else {
        currentButton.removeAttribute('disabled');
      }
      
      // Update button text
      const newButtonText = newButton.querySelector('span');
      const currentButtonText = currentButton.querySelector('span');
      if (newButtonText && currentButtonText) {
        currentButtonText.innerHTML = newButtonText.innerHTML;
      }
    }

    // Update hidden input variant ID
    const newInput = html.querySelector('.floating-atc__form input[name="id"]');
    const currentInput = this.querySelector('.floating-atc__form input[name="id"]');

    if (newInput && currentInput) {
      currentInput.value = newInput.value;
      if (newInput.hasAttribute('disabled')) {
        currentInput.setAttribute('disabled', 'disabled');
      } else {
        currentInput.removeAttribute('disabled');
      }
    }

    // Update pre-order display + line property input
    const preOrderText = html.querySelector('.washing-size')?.dataset.preOrderText || '';
    const preOrderEl = this.querySelector('.floating-atc__preorder');
    if (preOrderEl) {
      if (preOrderText) {
        const textSpan = preOrderEl.querySelector('.floating-atc__preorder-text');
        if (textSpan) textSpan.innerHTML = '<strong>Pre-order:</strong> ' + preOrderText;
        preOrderEl.classList.remove('floating-atc__preorder--hidden');
      } else {
        preOrderEl.classList.add('floating-atc__preorder--hidden');
      }
    }

    const form = this.querySelector('.floating-atc__form form');
    if (form) {
      let poPropInput = form.querySelector('.pre-order-property-input');
      if (preOrderText) {
        if (!poPropInput) {
          poPropInput = document.createElement('input');
          poPropInput.type = 'hidden';
          poPropInput.name = 'properties[Pre-order]';
          poPropInput.className = 'pre-order-property-input';
          form.appendChild(poPropInput);
        }
        poPropInput.value = preOrderText;
        poPropInput.disabled = false;
      } else if (poPropInput) {
        poPropInput.value = '';
        poPropInput.disabled = true;
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('floating-atc', FloatingATC);
